import React, { useState } from 'react';
import { HStack } from '@chakra-ui/react';
import { useColors } from '../../../../components/common/Color';
import HeaderSection from '../../../../components/common/Header/HeaderSection';
import BalanceTable from './BalanceTable';

function BalanceSheet() {
  const colors = useColors();


  return (
    <div>
      <HeaderSection
        title="Balance Sheet" 
        breadcrumb={["Dashboard", "Accounts", "Balance Sheet"]} 
      />

      <HStack align="start" w="full"  gap="0" mt={4} p={6}>
        <BalanceTable colors={colors} />

      </HStack>
    </div>
  );
}

export default BalanceSheet;
